import Animation from 'animation'
import ChartDrawAbortError from 'chart-draw-abort-error'

/*
 * Used when we can't animate. This forces a fresh redraw
 */
class InstantUpdateAnimation extends Animation {

  /* If we're switching chart types and there isn't a breakdown,
   * do an immediate update
   */
  _chartTypeChangeNoBreakdown (serie) {
    if (!this.previous.allSerieTypes[serie.id]) {
      return false
    }
    let type0 = this.previous.allSerieTypes[serie.id].type
      , type1 = serie.type

    return type0 !== type1 && this.chart.layout.breakdown.calculated
  }

  /*
   * If a 2nd level breakdown is added/removed, update immediately
   *
   * This will trigger an instant update anytime a 2nd level breakdown (i.e.
   * more than one plot) has a different length.
   */
  _secondLevelBreakdownChange (serie) {
    if (!this.previous.scalers.x) {
      return false
    }

    let p0 = this.previous.scalers.x.plotScale.domain()
      , p1 = this.scalers.x.plotScale.domain()

    return p0.length !== p1.length
  }

  match (serie) {
    if (this._chartTypeChangeNoBreakdown(serie)) {
      return true
    }

    if (this._secondLevelBreakdownChange(serie)) {
      return true
    }

    return false
  }

  bindAndAnimate () {
    this.chart.ee.emit('fresh-redraw', this.chart._data)
    throw new ChartDrawAbortError()
  }

}

export default InstantUpdateAnimation
